import firebase from "firebase";

export default class ChatMessage {
	constructor({is_deleted, is_deleted_for_me, is_seen, receiver, sender, text, time_stamp, is_group}) {
		this.is_deleted = is_deleted || false;
		this.is_deleted_for_me = is_deleted_for_me || false;
		this.receiver = receiver || [];
		this.sender = sender || 0;
		this.text = text || "";
		this.time_stamp = time_stamp || firebase.database.ServerValue.TIMESTAMP;
		if (is_group) {
			// Formar un objeto clave valor con todos los miembros del chat e.g { {34 : false }, {35 : false }}
			this.is_seen = this.receiver
				.filter((n) => +n !== +this.sender)
				.map((n) => ({[n]: false}))
				.reduce((valorAnterior, valorActual) => Object.assign(valorAnterior, valorActual));
		} else {
			this.is_seen = is_seen || false;
		}
	}
}
